<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-pencil mr-2" />Input Upload / Video 2</h5>
            <hr />
            <b-row align-v="center">
                <b-col md="4">
                    <b-form-group label="IMEI / No. Faktur PGI">
                        <b-input-group>
                            <b-input id="input-number" v-model="number" maxlength="60" @keydown.enter="searchNumber"
                                :disabled="!!inventoryId || isSubmitting" />

                            <b-input-group-append>
                                <b-button id="search-button" variant="primary" @click="searchNumber"
                                    :disabled="!!inventoryId || isSubmitting">
                                    <i class="fa fa-fw fa-search" /> {{ !$helper.detectMobile() ? "Cari" : '' }}
                                </b-button>
                                <!-- Reset -->
                                <b-button id="reset-button" variant="outline-danger" @click="onReset">
                                    <i class="fa fa-fw fa-times" /> {{ !$helper.detectMobile() ? "Reset" : '' }}
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                </b-col>

            </b-row>

            <div v-if="item && inventoryId">
                <b-button id="detail-button" v-b-toggle.collapse-1 variant="primary">Lihat Detail</b-button>
                <b-collapse id="collapse-1" class="mt-2">
                    <b-row class="mt-3">
                        <b-col md="6">
                            <div class="font-weight-bold">Jenis Barang</div>
                            {{ item.kind }}
                            <div class="font-weight-bold mt-3">Merk Barang</div>
                            {{ item.brand }}
                            <div class="font-weight-bold mt-3">Tipe Barang</div>
                            {{ item.type }}
                            <div class="font-weight-bold mt-3">Tahun / Generasi Barang</div>
                            {{ item.year || "-" }}
                        </b-col>
                        <b-col md="6">
                            <div class="font-weight-bold">No. Faktur PGI</div>
                            {{ item.no_faktur }}
                            <div class="font-weight-bold mt-3">IMEI / SN</div>
                            {{ item.imei_sn }}
                            <div class="font-weight-bold mt-3">Password</div>
                            {{ item.password || "-" }}
                            <div class="font-weight-bold mt-3">Grade / Kelengkapan dari PGI</div>
                            {{ item.grade_pgi || "-" }} / {{ item.is_batangan_pgi == 1 ? "Batangan" : "Lengkap" }}
                        </b-col>
                    </b-row>
                </b-collapse>

                <b-row>
                    <b-col>
                        <b-row class="mt-2">
                            <b-col md="2">
                                <b-select id="kategori-foto-select" class="mt-3" v-model="kategoriFoto" :options="kategoriFotoOpt" />
                            </b-col>
                            <b-col>
                                <b-button id="add-photo-button" class="mt-3" :disabled="isSubmitting" variant="primary" @click="addPhoto">
                                    <i class="fa fa-fw fa-plus" /> {{ !$helper.detectMobile() ? "Tambah Bagian" : '' }}
                                </b-button>
                            </b-col>

                            <b-col class="d-flex justify-content-end mt-3">
                                <b-button id="adjustment-button" :disabled="isSubmitting" variant="dark" v-b-tooltip.hover.top
                                    title="Adjustment Barang" @click="prepareAdjustment()">
                                    <i class="fa fa-fw fa-wrench" /> {{ !$helper.detectMobile() ? "Adjustment Kerusakan"
                                : '' }}
                                </b-button>
                                <b-button id="reprint-barcode-button" :disabled="isSubmitting" class="ml-2" variant="dark" v-b-tooltip.hover.top
                                    title="Reprint Barcode" @click="$bvModal.show('m-reprint-code')">
                                    <i class="fa fa-fw fa-barcode" /> {{ !$helper.detectMobile() ? "Reprint Barcode" :
                                '' }}
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row v-if="isLoadingPhotos" class="mt-3">
                            <b-col class="text-center py-5">
                                <b-spinner variant="dark" label="Loading..."></b-spinner>
                                <p class="mt-2 text-muted">Memuat data...</p>
                            </b-col>
                        </b-row>
                        <b-row v-else-if="!$helper.detectMobile()" class="mt-3">
                            <b-col v-for="(photo, index) in photos" :key="photo.id" cols="6">
                                <div class="upload-section mt-2">
                                    <div class="d-flex justify-content-between" :id="'photo-' + index">
                                        <p>{{ photo.name }}</p>
                                        <!-- refresh -->
                                        <b-button id="refresh-button" v-if="photo.isRequired" variant="outline-warning"
                                            size="sm" class="refresh-button">
                                            <i class="fa fa-fw fa-refresh" />
                                        </b-button>
                                        <b-button id="delete-button" v-if="!photo.isRequired"
                                            @click="confirmAction(index, photo, 'delete')" variant="outline-danger"
                                            size="sm" class="delete-button">
                                            <i class="fa fa-fw fa-trash" />
                                        </b-button>
                                    </div>
                                    <b-row class="mt-2">
                                        <b-col md="12">
                                            <div class="preview-photo" :id="'preview-photo-' + index">

                                                <div v-if="!photo.isVideo">
                                                    <img :id="photo.url" @click="showPreview(index)"
                                                        v-if="photo.file != null" :src="photo.url" alt="preview" />
                                                    <p :id="photo.url" @click="showPreview(index)" v-else-if="photo.url"
                                                        style="cursor:pointer;font-weight: bold"
                                                        class="font-weight-bold">
                                                        <i class="fa fa-eye mr-2" />Lihat Foto
                                                    </p>
                                                    <p v-else class="mt-2">No Photo</p>
                                                </div>

                                                <div v-if="photo.isVideo">
                                                    <video v-if="photo.file != null" :id="photo.url" width="100%" controls
                                                        @click="showPreview(index)">
                                                        <source :src="photo.url" type="video/mp4">
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <p :id="photo.url" @click="showPreview(index)" v-else-if="photo.url"
                                                        style="cursor:pointer" class="font-weight-bold">
                                                        <i class="fa fa-eye mr-2" />
                                                        Lihat Video
                                                    </p>
                                                    <p v-else class="mt-2">No Video</p>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col md="12">
                                            <div class="mt-2"
                                                :id="'upload-section-' + index"
                                                style="display: flex; flex-direction: column;gap: 3px; justify-content: center;">
                                                <input
                                                    type="file"
                                                    :id="'uploadFile-' + index"
                                                    class="custom-file-upload my-2"
                                                    @change="uploadFile($event, index)"
                                                    accept="image/jpeg, image/png, video/mp4, video/quicktime"
                                                    style="display: none;"
                                                />

                                                <!-- Browse Button to Trigger File Input -->
                                                <span
                                                    v-show="!isUpload"
                                                    class="custom-file-upload my-2"
                                                    @click="triggerFileInput(index)">
                                                    <i class="fa fa-fw fa-upload" />
                                                    Browse
                                                </span>

                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2" v-else>
                            <b-col class="mt-2" v-for="(photo, index) in photos" :key="photo.id" cols="12">
                                <div class="upload-section-mobile">
                                    <div class="d-flex justify-content-between" :id="'photo-' + index">
                                        <p>{{ photo.name }}</p>

                                        <b-button id="delete-button-mobile" v-if="!photo.isRequired"
                                            @click="confirmAction(index, photo, 'delete')" variant="outline-danger"
                                            size="sm" class="delete-button">
                                            <i class="fa fa-fw fa-trash" />
                                        </b-button>
                                    </div>


                                    <div class="d-flex justify-content-between align-items-center" style="gap:5px;" id="photo-actions">
                                        <div>
                                            <b-button id="preview-button" :variant="photo.url == null || isUpload ? 'outline-warning' : 'outline-success'"
                                                :disabled="photo.url == null || isUpload" @click="showPreview(index)">
                                                <i class="fa fa-eye" />
                                            </b-button>
                                        </div>
                                        <div :id="uploadKey" style="display: flex; width: 100%; flex-direction: column; gap: 3px; justify-content: center;">
                                            <!-- Hidden File Input -->
                                            <input
                                                type="file"
                                                :id="'uploadFile-' + index"
                                                class="custom-file-upload my-2"
                                                @change="uploadFile($event, index)"
                                                accept="image/jpeg, image/png, video/mp4, video/quicktime"
                                                style="display: none;"
                                            />

                                            <!-- Visible Button to Trigger File Input -->
                                            <button :disabled="isUpload"
                                                class="custom-file-upload my-2" style="width: 100%; background: transparent;"
                                                @click="triggerFileInput(index)" >
                                                <i class="fa fa-fw fa-upload" />
                                                Browse
                                            </button>
                                        </div>
                                        <div :id="uploadKey" class="d-flex" style="gap: 5px;">
                                            <b-button
                                                id="capture-button"
                                                v-if="!photo.isVideo" variant="outline-primary"
                                                @click="onCapture(index)"
                                                style="width: 100%;">
                                                <i class="fa fa-fw fa-camera" />
                                            </b-button>
                                        </div>
                                    </div>

                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>

            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />

        </b-card>


        <b-modal id="m-preview-photo" :title="
                previewPhoto
                    ? previewPhoto.isVideo
                        ? 'Preview Video'
                        : 'Preview Foto'
                    : 'Preview'
            " hide-footer>
            <div v-if="previewPhoto">
                <img v-if="!previewPhoto.isVideo" :src="previewPhoto.url" alt="preview"
                    style="max-width: 100%; max-height: 100%; object-fit: contain;" loading="lazy" id="preview-photo-img" />
                <video v-else controls style="max-width: 100%; max-height: 100%; object-fit: contain;" id="preview-photo-video">
                    <source :src="previewPhoto.url" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
        </b-modal>

        <b-modal v-if="activeItem" id="m-item-to-adjust" title="Adjustment Barang Masuk" size="xl" centered
            no-close-on-backdrop no-close-on-esc hide-footer>
            <div>
                <b-table bordered hover show-empty no-local-sorting :items="invoiceAdjustments" :fields="fieldsAdjust"
                    responsive class="my-4">
                    <template v-slot:empty>
                        Tidak ada adjustment.
                    </template>
                    <template v-slot:cell(category)="row">
                        <div>
                            {{ row.item.category_name || '-' }}
                        </div>
                    </template>
                    <template v-slot:cell(name)="row">
                        <div>
                            {{ row.item.name || '-' }}
                        </div>
                    </template>
                    <template v-slot:cell(adjustment)="row">
                        <b-input-group :prepend="checkAdjustment(row.item).prepend">
                            <b-form-input id="adjustment-input"
                             :value="
                                    String(row.item.adjustment).replace('-', '')
                                "
                            :class="checkAdjustment(row.item).class"
                            @input="sanitize(row.item)"
                                disabled></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(adjustmentPercent)="row">
                        <b-input-group append="%">
                            <b-form-input id="adjustment-percent-input" v-model="row.item.adjustmentPercentage" @input="changeAdjustment"
                                disabled></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex">
                            <b-button id="damage-image-button" size="sm" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                                :disabled="isSubmitting"
                                @click="prepareAdjImage(row.item)">
                                <i class="fa fa-fw fa-picture-o" />
                            </b-button>
                            <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Edit Harga"
                                :disabled="isSubmitting || !hasEditAdjPricePermission"
                                @click="editAdjustment(row.item)">
                                <i class="fa fa-fw fa-pencil" />
                            </b-button>
                            <b-button id="delete-row-button" variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                                :disabled="activeItem.status == '3' || !hasDeleteAdjInventoryPermission" @click="deleteRow(row.item)">
                                <i class="fa fa-fw fa-times" />
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <b-row>
                    <b-col md="6">
                        <b-button id="add-adjustment-button" variant="dark" @click="prepareAddAdjustment" v-if="hasAddAdjInventoryPermission"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment) || isSubmitting">
                            <i class="fa fa-plus mr-2" />Tambah Keterangan
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal v-if="activeItem" id="m-image"
            :title="'Edit Gambar Kerusakan Item ' + activeItem.type + ' (' + activeAdjustment.name + ')'" size="xl"
            no-close-on-backdrop no-close-on-esc hide-footer >
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.computedImageUrl"
                            blank-src="image-loading.gif" block alt="Image Preview" id="media-preview-image"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url" id="media-preview-video">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                                :type="mediaPreview.type">

                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image" id="no-image-preview"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.urlCompress)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.computedImageUrl || '/img/img-loading.gif'"
                                blank-src="/img/image-loading.gif" block :alt="media.altText" :id="'media-scroll-preview-' + index"></b-img-lazy>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <b-button id="refresh-image-button" block variant="warning" class="mb-2" @click="onRefreshImage()">
                        Refresh
                    </b-button>

                    <span id="uploadFile" class="mb-2">
                        <b-button
                            id="upload-new-item-button"
                            block
                            variant="success"
                            @click="triggerFileInputForAdjustment"
                            :disabled="!hasAddPhotoAdjPermission">
                            {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                        </b-button>
                        <input
                            type="file"
                            ref="fileInputAdjustment"
                            style="display: none;"
                            accept="image/jpeg, image/png, video/mp4, video/quicktime"
                            @change="uploadFileForAdjustment"
                            multiple
                        />
                    </span>

                    <b-button id="open-image-button" block variant="primary" class="mt-2"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <b-button id="delete-image-button" block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting || !hasDeletePhotoAdjPermission"
                        @click="onDeleteImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div id="media-disclaimer" class="mt-3 media-disclaimer">
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                            WEBM.</small><br>
                        <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
        </b-modal>

        <!-- Confirmation Modal -->
        <b-modal id="m-confirm" centered hide-footer>
            <template v-slot:modal-title>
                <h4 id="confirm-title">{{ confirmTitle }}</h4>
            </template>

            <p id="confirm-message">{{ confirmMessage }}</p>

            <div class="d-flex justify-content-end">

                <b-button id="cancel-button" class="mr-2" variant="secondary" @click="$bvModal.hide('m-confirm')">Batal</b-button>
                <b-button id="confirm-button" variant="primary" @click="submitAction">{{ confirmActionText }}</b-button>
            </div>

        </b-modal>

        <b-modal id="m-add-adjustment" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group id="jenis-barang-group" label="Jenis Barang">
                <b-form-select v-model="addAdj.kind" :options="addAdj.optKind" disabled />
            </b-form-group>
            <b-form-group id="kategori-kerusakan-group" label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group id="keterangan-group" label="Keterangan">
                <b-form-select
                    v-model="addAdj.name"
                    :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0"
                    @change="onSelectAdjustment"
                />
            </b-form-group>
            <b-form-group id="adjustment-harga-nominal-group" label="Adjustment Harga (Nominal)">
                <b-input-group :prepend="`Rp. ${addAdj.is_increment == 0 ? '-' : ''}`">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                    :class="{ 'text-danger': addAdj.is_increment == 0,
                                'text-success': addAdj.is_increment == 1,
                             }"
                        :disabled="$helper.isBlank(addAdj.name) || activeItem.fixing_adjustment == 1 || addAdj.hasAdjustmentPrice"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button id="confirm-add-adjustment-button" variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-capture-camera" title="Capture Camera" no-close-on-backdrop no-close-on-esc hide-footer
            @hidden="onCaptureClose">
            <div class="d-flex justify-content-center">
                <video ref="videoElement" id="video-element" style="width: 100%; height: auto; object-fit: cover; aspect-ratio: 3 / 4; transform: scaleX(1);" autoplay></video>
            </div>
            <div class="mt-4 text-center">
                <b-button block variant="primary" id="capture-button" :disabled="isSubmitting" @click="captureCamera()">
                    {{ isSubmitting ? "Menyimpan..." : "Capture" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-reprint-code" title="Reprint Barcode" centered no-close-on-backdrop hide-footer
            @shown="$refs.passcode.focus()">
            <b-form-group id="passcode-reprint-group" label="Passcode Reprint">
                <b-form-input type="password" ref="passcode" maxlength="10" v-model="passcode"
                    @keydown.enter="getReprintBarcode" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button id="reprint-button" variant="primary" :disabled="isSubmitting" @click="getReprintBarcode">
                    {{ isSubmitting ? "Mengambil..." : "Reprint" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-reprint-barcode" title="Reprint Barcode" no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="barcode-iframe" :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                         <b-button v-if="isGold" id="toggle-mini-button" variant="dark" class="ml-2" @click="toggleMiniBarcode">
                            Print {{ barcodeType == 'mini' ? 'Barcode' : 'Mini' }}
                        </b-button>
                        <b-button v-else id="toggle-barcode-button" variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodePage == '1' ? 'Barcode tanpa harga' : 'Barcode ada harga' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button id="close-barcode-modal-button" variant="primary" @click="$bvModal.hide('m-reprint-barcode')">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-duplicate-imei" title="Pilih Inventaris" size="xl" no-close-on-backdrop no-close-on-esc
            hide-footer>

            <b-table responsive striped hover :items="arrDuplicateImei" :fields="fieldsDuplicate">
                <template v-slot:cell(no_faktur)="{ item }">
                    <strong style="cursor: pointer;">
                        {{ item.no_faktur }}

                        <b-button id="search-duplicate-imei-button" @click="searcNoDuplicateImei(item)" variant="primary" size="sm">
                            <i class="fa fa-fw fa-search" />
                        </b-button>
                    </strong>
                </template>

                <template v-slot:cell(barang)="{ item }">
                    <strong id="item-type">{{ item.type || "-" }}</strong>
                    <div id="item-details">
                        {{ item.kind || "-" }} - {{ item.brand || "-" }}
                    </div>
                </template>

                <template v-slot:cell(delivery)="{ item }">
                    <div id="delivery-source-branch">
                        {{ item.source || "-" }} - {{ item.branch || "-" }}
                    </div>
                    <div id="delivery-date">
                        {{ $helper.parseDate(item.delivery_date) || "-" }}
                    </div>
                </template>

                <template v-slot:cell(status)="{ item }">
                    <b-badge id="status-badge" :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </template>
            </b-table>

        </b-modal>

        <b-modal id="m-edit-adjustment" title="Edit Harga Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group :prepend="`Rp. ${editAdj.is_increment == 0 ? '-' : ''}`">
                    <b-form-input v-model="editAdj.adjustment" @input="sanitize(editAdj)"
                    :class="{ 'text-danger': editAdj.is_increment == 0,
                                'text-success': editAdj.is_increment == 1,
                             }"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEditAdjustment">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-sync-adjustment-confirm" title="Konfirmasi Update Harga Adjustment" centered hide-footer>
            <div>
                Apakah Anda yakin ingin mengupdate harga adjustment dengan data rumus?
            </div>
                <div class="mt-4 text-right">
                    <b-button variant="secondary" @click="$bvModal.hide('m-sync-adjustment-confirm')" :disabled="isSubmitting">
                        Batal
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="syncAdjustmentPrice" :disabled="isSubmitting">
                        {{ isSubmitting ? "Memproses..." : "Ya, Update" }}
                    </b-button>
                </div>
        </b-modal>
    </div>
</template>

<script>
import DetailBarang from './DetailBarang.vue'
import ModalInputBarangMasukExternal from './ModalInputBarangMasukExternal.vue'
import lodash from 'lodash'
import Uploading from "./Uploading.vue"
import LoadingOverlay from './LoadingOverlay.vue'
import EnumPermissions from '@/shared/enum-permissions'

export default {
    components: {
        DetailBarang,
        ModalInputBarangMasukExternal,
        Uploading,
        LoadingOverlay,
    },
    data() {
        return {

            isSubmitting: false,
            inventoryId: "",
            kindId: "",
            status: null,

            number: "",
            noFaktur: "",

            previewPhoto: null,
            photos: [],
            isLoadingPhotos: false,
            kategoriFotoOpt: [],
            item: null,
            kategoriFoto: 0,

            activeItem: null,
            activeIndex: null,
            activePhoto: null,
            activeType: null,

            invoiceAdjustments: [],

            optCategory: [],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            initStatus: 0,

            isDownloadExcelAllowed: false,
            isMoveInventoryAllowed: false,
            isRequestResetAllowed: false,

            activeId: 0,
            passcode: "",
            resetReason: "",
            resetType: "",

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
                is_increment: null,
            },
            editAdj: {
                adjustmentId: null,
                adjustment: "",
                pendingSyncAdjustmentId: null,
                is_increment: null,
            },

            activeAdjustment: {},

            isChangeAdjustment: false,
            isChangePhotoAdjustment: false,

            barcodeLink: "",
            barcodeLinkDamage: "",
            barcodeLinkMini: "",

            barcodeType: 'barcode',

            barcodePage: '1',
            barcodeToggleCooldown: false,

            mediaStream: null,
            indexMedia: 0,
            isFlashOn: false,

            confirmTitle: "",
            confirmMessage: "",
            confirmActionText: "",

            uploadKey: 0,
            isUpload: false,

            activeAdjustmentRow: null,

            arrDuplicateImei: "",

            fieldsDuplicate: [
                { key: 'no_faktur', label: 'No Faktur', sortable: true },
                { key: 'barang', label: 'Barang', sortable: true },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'delivery', label: 'Pengiriman', sortable: true },
            ],

            isShowLoadingOverlay: false,
            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null,
            },

        }
    },
    methods: {

        parseStatusVariant(status) {

            switch (status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch (status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                default: return "LAINNYA"
            }

        },

        searcNoDuplicateImei(item) {
            this.inventoryId = item.id
            this.getItems()
            this.$bvModal.hide("m-duplicate-imei")
        },

        duplicateImeiFetch(imei) {
            this.$axios.get("delivery/inventory/doubleimei", {
            params: { imei_sn: imei }
            }).then(res => {
            this.arrDuplicateImei = res.data.data

            this.$bvModal.show("m-duplicate-imei")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        searchNumber() {

            if (this.isSubmitting) return

            this.isSubmitting = true
            this.$axios.get("inventory-photo/get-inventory?number=" + this.number).then(res => {

                if (res.data.data.duplicateImei) {
                    this.noFaktur = ""
                    this.duplicateImeiFetch(this.number)
                } else {
                    this.inventoryId = res.data.data.id
                    this.getItems()
                }


            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        addPhoto() {

            const kategoriFotoData = this.kategoriFotoOpt.find(item => item.value == this.kategoriFoto)

            this.photos.push({
                id: null,
                idCategory: kategoriFotoData.value,
                name: kategoriFotoData.text,
                url: null,
                file: null,
                isVideo: kategoriFotoData.isVideo,
                isAddedServer: false,
                isUploaded: false

            })

            this.kategoriFoto = ""

        },

        onDeletePhoto(index, item) {

            if (item.isAddedServer) {
                this.$axios.get(`delivery/hapus-foto/${item.id}`).then(() => {
                    this.$helper.toastSuccess(this, `Bagian ${item.name} berhasil dihapus`)
                    this.photos.splice(index, 1)
                }).catch(error => this.$helper.parseError(this, error))
            } else {
                this.photos.splice(index, 1)
            }
        },

        async showPreview(index) {
                const photo = this.photos[index];

                // Validate the compressed URL (or the original URL as a fallback)
                const isCompressAvailable = photo.urlCompress
                    ? await this.checkImgUrlStatus(photo.urlCompress)
                    : false;

                this.previewPhoto = {
                    ...photo,
                    url: isCompressAvailable ? photo.urlCompress : photo.url,
                };

                this.$bvModal.show("m-preview-photo");
        },

        async getItems() {
            this.onResetPhoto()
            try {
                const res = await this.$axios.get(`delivery/inventory/${this.inventoryId}?source=fovid`)
                this.item = res.data.data
                this.kindId = this.item.kind_id
                this.activeItem = res.data.data
                this.status = this.item.status

                await Promise.all([
                    this.getKategoriFotoOpt(),
                    this.getPhotos()
                ])

                this.initStatus = 1
            } catch (error) {
                this.initStatus = -1
                this.$helper.parseError(this, error)
            }
        },

        checkAdjustment(item) {
            let val = Number(String(item.adjustment).replace(/\./g, ""));
            let result = {
                class: "",
                prepend: "Rp. "
            };

            if (val == 0) {
                result.class = "text-black";
            } else if (val < 0) {
                result.class = "text-danger";
                result.prepend = "Rp. -";
            } else if (val > 0) {
                result.class = "text-success";
            }
            return result;
        },

        getInventoryAdjustment(id) {
            let param = "?id=" + id;
            this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                this.invoiceAdjustments = res.data.data.map(item => {
                    let adjustmentObj = {
                        adjustment_id: item.adjustments_id,
                        name: item.adjustments_name,
                        adjustment: item.adjustment,
                        adjustmentPercentage: item.adjustment_percentage,
                        category_name: item.category_name,
                        hasAdjFormula: item.has_adj_formula,
                        is_increment: item.is_increment,
                    };
                    return adjustmentObj;
                });

                this.invoiceAdjustments.forEach(adj => this.sanitize(adj, true));
                if (this.invoiceAdjustments.length <= 0) this.addRow();
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false);
        },

        async getKategoriFotoOpt() {
            await this.$axios.get(`master/kategori-foto/selection?kind_id=${this.kindId}`).then(res => {
                this.kategoriFotoOpt = res.data.data.filter(item => item.is_required != 1).map(item => {
                    return {
                        value: item.id,
                        text: item.name,
                        isVideo: item.is_video
                    }
                })

            })
                .catch(error => this.$helper.parseError(this, error))
        },



        async getPhotos() {
            this.isLoadingPhotos = true;
            await this.$axios.get('delivery/get-foto/' + this.inventoryId).then(res => {
                let responseData = res.data.data

                this.photos = responseData.filter((f) => f.master_is_required == 1 || f.path != null).map(photo => {
                        return ({
                            id: photo.id || null,
                            idCategory: photo.master_id || null,
                            name: photo.master_name || "-",
                            url: photo.path || null,
                            urlCompress: photo.path_compress || null,
                            file: null,
                            isVideo: photo.master_is_video === 1,
                            isRequired: photo.master_is_required === 1,
                            isAddedServer: photo.path !== null,
                            isUploaded: false
                        })
                }).sort((a, b) => b.isRequired - a.isRequired)

            }).catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingPhotos = false;
            })
        },

        onReset() {
            this.number = ""
            this.noFaktur = ""
            this.item = null
            this.inventoryId = ""
            this.photos = []
            this.isUpload = false
        },

        onResetPhoto() {
            this.photos = []
            this.kategoriFotoOpt = []
        },

        async initialPhotos() {
            await this.getKategoriFotoOpt()
            await this.getPhotos()
        },

        // TODO: refactor this code :(
        prepareAdjustment() {

            if (!this.isAllowStatusAdjustment(this.status)) {
                this.$helper.toastError(this, "Tidak dapat mengubah adjustment kerusakan. Inventory harus berstatus READY atau RETUR.")
                return;
            }

            this.invoiceAdjustments = []
            this.activeItem = this.item
            this.isSubmitting = true

            this.$axios.get("category/selection?item_kind_id=" + this.activeItem.kind_id).then(res => {
                this.optCategory = res.data.data.map(item => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })

                this.getInventoryAdjustment(this.item.id)

                this.$bvModal.show("m-item-to-adjust")
                this.isChangeAdjustment = false

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })

        },
        sanitize(item, allowNegative = false) {
            let str = String(item.adjustment);
            let isNegative = str.startsWith("-");

            if (allowNegative && isNegative) {
                str = str.substring(1);
            }

            let cleaned = str.replace(/\./g, "");
            let res = cleaned
                .replace(/[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            if (allowNegative && isNegative) {
                res = "-" + res;
            }

            item.adjustment = res;
            this.isChangeAdjustment = true;
        },

        onChangeRowCategory(index) {

            this.invoiceAdjustments[index].name = ""
            this.invoiceAdjustments[index].adjustmentSelect = null
            this.invoiceAdjustments[index].optAdjustments = []

            if (!this.$helper.isBlank(this.invoiceAdjustments[index].category)) {
                let param = "?item_kind_id=" + this.item.kind_id
                param += "&category_id=" + this.invoiceAdjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.invoiceAdjustments[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        deleteRow(item) {
            const isConfirmed = confirm("Apakah Anda yakin ingin menghapus data adjustment ini?");
            if (!isConfirmed) return;

            const payload = {
                adjustment_id: item.adjustment_id,
                inventory_id: this.activeItem.id
            }

            this.isSubmitting = true
            this.$axios.delete("inventory/delete-invoice-adjustment", { data: payload }).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Dihapus!")
                this.getInventoryAdjustment(this.activeItem.id)
                this.isChangeAdjustment = true
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        editAdjustment(item) {
            if (item.hasAdjFormula) {
                this.editAdj.pendingSyncAdjustmentId = item.adjustment_id;
                this.$bvModal.show('m-sync-adjustment-confirm');
                return
            }
            this.editAdj.adjustmentId = item.adjustment_id;
            this.editAdj.adjustment = ""
            this.editAdj.is_increment = item.is_increment;
            this.$bvModal.show("m-edit-adjustment")
        },

        syncAdjustmentPrice() {
            const payload = {
                inventory_id: this.activeItem.id,
                adjustment_id: this.editAdj.pendingSyncAdjustmentId
            }

            this.isSubmitting = true
            this.$axios.patch("inventory/sync-adjustment-price", payload).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Disinkronisasi!")
                this.getInventoryAdjustment(this.activeItem.id)
                this.editAdj.pendingSyncAdjustmentId = null
                this.$bvModal.hide("m-sync-adjustment-confirm")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false);
        },

        confirmEditAdjustment() {
            if (this.$helper.isBlank(this.editAdj.adjustment)) {
                this.$helper.toastError(this, "Data Adjustment Nominal tidak boleh kosong !")
                return
            }

             const payload = {
                adjustment_id: this.editAdj.adjustmentId,
                inventory_id: this.activeItem.id,
                adjustment: this.$helper.toNumber(this.editAdj.is_increment == 0 ? '-' + this.editAdj.adjustment : this.editAdj.adjustment)
            }

            this.isSubmitting = true
            this.$axios.patch("inventory/edit-invoice-adjustment", payload).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Diubah!")
                this.getInventoryAdjustment(this.activeItem.id)
                this.$bvModal.hide("m-edit-adjustment")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false);
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item
            this.isSubmitting = true
            let param = "?inventory_id=" + this.activeItem.id
            param += "&adjustment_id=" + this.activeAdjustment.adjustment_id
            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        url: res.data.data[i].path,
                        urlCompress: res.data.data[i].path_compress,
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image")
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.activeItem.kind_id, text: this.activeItem.kind }
            ]
            this.addAdj.kind = this.activeItem.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            if (this.activeItem.fixing_adjustment) {
                this.addAdj.adjustment = "0"
                this.addAdj.adjustmentPercentage = ""
            } else {
                this.addAdj.adjustment = ""
                this.addAdj.adjustmentPercentage = ""
            }
            this.$bvModal.show("m-add-adjustment")
        },
        changeAdjustment() {
            this.isChangeAdjustment = true
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].urlCompress == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onOpenImage(url) {
            window.open(url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'

                        let payload = new FormData()

                        payload.append("inventory_id", this.inventoryId)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(() => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                            if (this.isChangePhotoAdjustment) {
                                this.isChangeAdjustment = true
                            }

                        })
                            .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
            this.isChangePhotoAdjustment = true
        },

        async submitAction() {

            this.$bvModal.hide("m-confirm")

            if (this.activeType == 'delete') {
                this.onDeletePhoto(this.activeIndex, this.activePhoto)
            }

        },

        confirmAction(index, photo, type) {
            this.activeIndex = index
            this.activePhoto = photo
            this.activeType = type

            if (type == 'delete') {
                this.confirmTitle = "Hapus Foto"
                this.confirmMessage = "Apakah anda yakin ingin menghapus foto ini?"
                this.confirmActionText = "Hapus"
            }

            this.$bvModal.show("m-confirm")
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            this.addAdj.hasAdjustmentPrice = false
            this.addAdj.adjustment = ""
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    this.addAdj.selectedCategoryAdjustments = res.data.data;
                    this.isSubmitting = false
                })
            }
        },

        confirmAdd(id) {
            let confirmable = true

            for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                let adj = this.invoiceAdjustments[i]

                if (this.$helper.isBlank(adj.adjustment) && this.$helper.isBlank(adj.adjustmentPercentage)) {
                    confirmable = false
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }

            }

            if (confirmable) {
                let payload = new FormData()
                let jsonData = {
                    adjInvoice: this.invoiceAdjustments.map(it => {
                        if (this.$helper.isBlank(it.adjustmentPercentage)) {
                            return {
                                name: it.name,
                                adjustment: this.$helper.toNumber(it.adjustment),
                                adjustmentPercentage: null,
                                adjustment_id: it.adjustment_id
                            }
                        }
                        else {
                            return {
                                name: it.name,
                                adjustment: parseInt(this.activeItem.final_price * parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100),
                                adjustmentPercentage: Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2),
                                adjustment_id: it.adjustment_id
                            }
                        }
                    })
                }

                payload.append("data", JSON.stringify(jsonData))
                payload.append("id", id)
                payload.append("changed", this.isChangeAdjustment)

                this.isSubmitting = true
                this.$axios.post("inventory/update-invoice-adjustments", payload).then(() => {
                    this.$helper.toastSuccess(this, "Update Adjustment Berhasil!")
                    this.$bvModal.hide("m-item-to-adjust")
                    this.getItems()
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }

        },

        // TODO: refactor this code :(
        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong !")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) && this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                if (!this.activeItem.fixing_adjustment) {
                    this.$helper.toastError(this, "Salah satu dari data Adjustment Nominal atau Persentase tidak boleh kosong !")
                    return
                }
            }

            let payload = new FormData()

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.addAdj.name)
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append("adjustment", this.$helper.toNumber(this.addAdj.is_increment == 0 ? '-' + this.addAdj.adjustment : this.addAdj.adjustment))
            }
            else {
                payload.append("adjustment", parseInt(this.activeItem.final_price * parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100))
                payload.append("adjustment_percentage", Number(parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2))
            }

            this.isSubmitting = true
            this.$axios.post("inventory/add-invoice-adjustments", payload).then(() => {

                this.getInventoryAdjustment(this.activeItem.id)

                this.$bvModal.hide("m-add-adjustment")
                this.isChangeAdjustment = true
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },


        onCapture(index) {

            this.$bvModal.show("m-capture-camera")
            this.indexMedia = index
            const this_ = this

            const constraints = {
                video: {
                    facingMode: "environment",
                    width: { min: 1024, ideal: 1280, max: 1920 },
                    height: { min: 576, ideal: 720, max: 1080 },
                    advanced: [{ zoom: 1.0 }],
                    aspectRatio: { width: 1, height: 1 },
                    resizeMode: 'none'
                }
            };

            navigator.mediaDevices.getUserMedia(constraints)
                .then(function (stream) {

                    const videoTrack = stream.getVideoTracks()[0];
                    const capabilities = videoTrack.getCapabilities();

                    if (capabilities.zoom) {
                        try {
                            videoTrack.applyConstraints({
                                advanced: [{ zoom: 1.0 }],
                            })
                        } catch (error) {
                            console.log('Zoom is not supported', error);
                        }
                    }

                    if (this_.$refs.videoElement) {
                        this_.$refs.videoElement.srcObject = stream;
                    }

                    this_.mediaStream = stream;
                })
                .catch(function (error) {
                    console.error('Error accessing the camera: ', error);
                });
        },

        captureCamera() {

            const videoElement = this.$refs.videoElement;
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            const context = canvas.getContext('2d');
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

            context.font = "20px Arial";
            context.fillStyle = "white";
            context.textAlign = "center";
            context.fillStyle = "rgba(0, 0, 0, 0.5)";
            context.fillRect(0, canvas.height - 30, canvas.width, 30);
            context.fillStyle = "white";
            context.fillText(this.$helper.formatDate(new Date()), canvas.width / 2, canvas.height - 10);

            const imageUrl = canvas.toDataURL('image/jpeg');

            // convert base64 to file
            const file = this.$helper.base64ToFile(imageUrl, 'image.jpg')

            // Stop media stream when modal is closed
            if (this.mediaStream) {
                this.mediaStream.getTracks().forEach(track => track.stop());
                this.mediaStream = null; // Reset the mediaStream property
            }

            this.photos[this.indexMedia].file = file

            this.isFlashOn = false

            const event = { target: { files: [file] } };

            this.uploadFile(event, this.indexMedia);

            this.$bvModal.hide("m-capture-camera")

        },

        onCaptureClose() {
            if (this.mediaStream) {
                this.mediaStream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }
            this.mediaStream = null;
            this.isFlashOn = false
            this.$bvModal.hide("m-capture-camera")
        },
         getReprintBarcode() {

            this.isSubmitting = true
            let payload = {
                id: this.item.id,
                passcode: this.passcode
            }

            this.$axios.post("inventory/reprint-barcode", payload).then(res => {

                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.barcodeLinkMini = res.data.data.link_mini
                this.$bvModal.hide("m-reprint-code")
                this.$bvModal.show("m-reprint-barcode")
                this.passcode = ""

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getBarcodeLink() {
             if (this.barcodeType == 'mini') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkMini}`
            }
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}?page=${this.barcodePage}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodePage == '1') this.barcodePage = '2'
            else this.barcodePage = '1'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        toggleMiniBarcode() {
            if (this.barcodeType === 'mini') {
                this.barcodeType = 'barcode';
            } else {
                this.barcodeType = 'mini';
            }
        },

        handleBeforeUnload(event) {
            if (this.isUpload) {
                event.preventDefault();
                event.returnValue = ''; // Beberapa browser membutuhkan returnValue di-set ke string kosong
            }
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },
        async checkImgUrlStatus(url) {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = url;
            });
        },
        async setImageSource(media) {
            this.$set(media, 'computedImageUrl', '/img/image-loading.gif');

            let computedUrl;

            if (media.media === 'video') {
                computedUrl = '/img/video-thumbnail.png';
            } else if (media.status === 'upload') {
                computedUrl = media.url;
            } else {
                const urlCompress = media.urlCompress;
                const isUrlCompressAccessible = await this.checkImgUrlStatus(urlCompress);
                computedUrl = isUrlCompressAccessible
                    ? urlCompress
                    : media.url;
            }

            this.$set(media, 'computedImageUrl', computedUrl);
        },
         //  ============ this upload file to s3 ============
        async getPresignedUrl(fileName, fileType, directoryPath) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(new Date());
            const response = await this.$axios.post('get-presigned-url', {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.item.no_faktur,
                directory_path: directoryPath,
            });
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type,
                },
            });
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },
        async uploadFile(event, index) {
            const file = event.target.files[0];
            if (!file) return;

            // Validate file type and size
            const allowedImageTypes = ['image/jpeg', 'image/png'];
            const allowedVideoTypes = ['video/mp4', 'video/quicktime'];
            const maxSize = 400 * 1024 * 1024; // 400MB

            if (allowedImageTypes.includes(file.type) && this.photos[index].isVideo) {
                this.$helper.toastError(this, `File ${file.name} tidak sesuai dengan tipe file yang diizinkan`);
                return;
            }
            if (allowedVideoTypes.includes(file.type) && !this.photos[index].isVideo) {
                this.$helper.toastError(this, `File ${file.name} tidak sesuai dengan tipe file yang diizinkan`);
                return;
            }
            if (file.size > maxSize) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.");
                return;
            }

            // Show loading state
            this.isShowLoadingOverlay = true;

            try {
                // Fetch presigned URL from the backend
                const { presigned_url, file_path } = await this.getPresignedUrl(file.name, file.type, "invtrypht");

                // Upload file to S3 using the presigned URL
                await this.uploadToS3(file, presigned_url);

                // Send metadata to the backend
                const payload = {
                    id_inventory: this.inventoryId,
                    id_category_photos: this.photos[index].idCategory,
                    size_file: file.size,
                    file_name: file_path,
                    is_video: !allowedImageTypes.includes(file.type),
                    id_photo: this.photos[index].id,
                    upload_provider: 'aws',
                    no_faktur: this.item.no_faktur,
                };
                this.uploadTimeStamp.startSaveFile = this.formatTime(new Date());
                await this.$axios.post('delivery/input-foto', payload, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());

                // Success feedback
                this.$helper.toastSuccess(this, `Bagian ${this.photos[index].name} berhasil diupload`);
                this.onResetPhoto();
                this.initialPhotos();
            } catch (error) {
                console.log("Upload file", error);
                this.$helper.toastError(this, "Gagal mengunggah media");
            } finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },
        triggerFileInput(index) {
            const fileInput = document.getElementById(`uploadFile-${index}`);
            if (fileInput) {
                fileInput.click();
            }
        },
        triggerFileInputForAdjustment() {
            this.$refs.fileInputAdjustment.click();
        },
        async uploadFileForAdjustment(event) {
            const files = Array.from(event.target.files); // Convert FileList to an array
            if (!files || files.length === 0) return;

            // Validate file types and sizes
            const allowedImageTypes = ['image/jpeg', 'image/png'];
            const allowedVideoTypes = ['video/mp4', 'video/quicktime'];
            const maxSize = 400 * 1024 * 1024; // 400MB
            let totalSize = 0;

            for (const file of files) {
                if (!allowedImageTypes.includes(file.type) && !allowedVideoTypes.includes(file.type)) {
                    this.$helper.toastError(this, "Jenis file tidak valid. Silakan unggah gambar (JPG, PNG) atau video (MP4, MOV).");
                    return;
                }
                totalSize += file.size;
                if (totalSize > maxSize) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.");
                    return;
                }
            }

            // Show loading state
            this.isShowLoadingOverlay = true;

            try {
                const payload = new FormData();
                for (const file of files) {
                    // Fetch presigned URL from the backend
                    const { presigned_url, file_path } = await this.getPresignedUrl(file.name, file.type, "adjdmgpht");

                    // Upload file to S3 using the presigned URL
                    await this.uploadToS3(file, presigned_url);


                    // Append file metadata to the payload
                    payload.append("url[]", file_path);
                    payload.append("fileName[]", file_path);
                }

                // Add inventory and adjustment IDs to the payload
                payload.append("inventory_id", this.inventoryId);
                payload.append("adjustment_id", this.activeAdjustment.adjustment_id);
                payload.append("upload_provider", "aws");

                this.uploadTimeStamp.startSaveFile = this.formatTime(new Date());

                // Send the payload to the backend
                await this.$axios.post("adjustment-damaged-photo/update", payload);


                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());
                this.isShowLoadingOverlay = false;
                this.$helper.toastSuccess(this, "Gambar/video berhasil diunggah!");
                this.resetUploadTimestamp();
                this.$bvModal.hide("m-image")
            } catch (error) {
                console.error("Upload file adjustment", error)
                this.$helper.toastError(this, "Gagal mengunggah media");
            }  finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },
        formatTime(date) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        },
        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null,
            };
        },
        isAllowStatusAdjustment(status) {
            const allowedStatus = [2, 4]; // only Ready and Retur;
            return allowedStatus.includes(status);
        },
        onSelectAdjustment(e) {
            const selected = this.addAdj.selectedCategoryAdjustments.find(
                adj => adj.id === e
            );
            const adjPercentages = selected.adjustment_percentages;

            this.addAdj.is_increment = selected.is_increment;

            if (!adjPercentages) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            const basePrice = this.activeItem.final_price;

            const adjustmentObj = adjPercentages.find(
                range => basePrice >= range.from && basePrice <= range.to
            );

            const adjustmentPrice = adjustmentObj ? adjustmentObj.nominal : null;

            if (adjustmentPrice === null) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            // set default amount adjustment based on range
            let cleaned = String(adjustmentPrice).replace(/\./g, "")
            let res = cleaned.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            this.addAdj.adjustment = res;
            this.addAdj.hasAdjustmentPrice = true;
        }
    },
    watch: {
        filterMediaList: {
            handler(newVal) {
                newVal.forEach(media => {
                    if (!media.computedImageUrl) {
                        this.setImageSource(media);
                    }
                });
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        },
        hasAddAdjInventoryPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.ADD_ADJ_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasDeleteAdjInventoryPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.DELETE_ADJUSTMENT_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasAddPhotoAdjPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.ADD_FOTO_ADJ.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasDeletePhotoAdjPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.DELETE_FOTO_ADJ.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasEditAdjPricePermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.EDIT_ADJUSTMENT_PRICE.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        isGold() {
            return this.item && this.item.category === "EMAS"
        }
    }, 
    created() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeRouteLeave(to, from, next) {
        if (this.isUpload) {
            // Show a confirmation dialog to the user
            const answer = window.confirm('You have unsaved changes. Do you really want to leave?');
            if (answer) {
                next(); // Allow navigation
            } else {
                next(false); // Prevent navigation
            }
        } else {
            next(); // Allow navigation if there are no unsaved changes
        }
    },


}
</script>

<style scoped>
.upload-section {
    border: 1px solid #20A8D7;
    padding: 20px;
    border-radius: 5px;
}

.upload-section-mobile {
    border: 1px solid #20A8D7;
    padding: 10px;
    border-radius: 5px;
}


.preview-photo div {
    /* max-width: 210px; */
    width: 100%;
    height: 125px;
    border: 1px solid #20A8D7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    color: #20A8D7;
    padding: 10px;
    margin-bottom: 5px;
}

.preview-photo div img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.preview-photo div video {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.custom-file-upload {
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border: 1px solid #20A8D7;
    border-radius: 5px;
    color: #20A8D7;
    text-align: center;
}

.custom-file-upload input[type="file"] {
    display: none;
}

.adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }

}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
